import userflow from 'userflow.js'

export const initUserFlow = ({ language, organisation, organisationId, planMetadata, userId }) => {
    userflow.init(import.meta.env.VITE_USERFLOW_TOKEN)
    userflow.identify(userId, {
        language: language,
        organisation_id: organisationId,
        organisation_units: organisation ? organisation.defaultDrawingUnits : undefined,
        plan_metadata: planMetadata ? JSON.stringify(planMetadata) : undefined,
        device_width: window.screen.width,
        device_height: window.screen.height,
        user_agent: window.navigator.userAgent,
        stripe_id: organisation ? organisation.paymentGatewayCustomerId : undefined,
    })
}

export const showTooltipsDisplay = (userId, showUserflowTooltips) => {
    if (userId) {
        userflow.init(import.meta.env.VITE_USERFLOW_TOKEN)
        userflow.identify(userId, { help_tips_toggle: showUserflowTooltips })
    }
}

export const showHelpWidget = (userId, showHelpWidget) => {
    if (userId) {
        userflow.init(import.meta.env.VITE_USERFLOW_TOKEN)
        userflow.identify(userId, { help_widget: showHelpWidget ? 'show' : 'hide' })
    }
}

export const showResourceCentre = (showResourceCentre) => {
    userflow.setResourceCenterLauncherHidden(!showResourceCentre)
}
